export default function PHP_dns_get_mx() {
  return (
    <div>
      <h1>PHP_dns_get_mx</h1>
    </div>
  );
}
